export const accounting_export = {
  rules: {
    fiche: {
      title: {
        edit_title: 'Fiche de la génération règle {{code}}',
        view_title: 'Fiche de la génération règle',
        new_title: "Création d'une nouvelle règle",
        treso_criteria: 'Critère Trésorerie',
        releve_criteria: 'Critère Relevé',
        flow_criteria: 'Critère Flux',
        filter_condition_imputation: 'Condition filtre et imputation',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        add: 'Ajouter',
      },
      champ_titles: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        mode: 'Génération du brouillard',
        validation: 'Validation du brouillard',
        type: 'Type',
        interface_generation: 'Interface génération',
        export_interface: 'Interface export',
        event: 'Evènement',
        category: 'Catégorie',
        direction_type: 'Type Sens',
        direction: 'Sens',
        flow: 'Flux',
        sub_type: 'Sous-Type',
        all_wording: 'Tous les libellés (Par défaut)',
        find_wording: 'Libellé recherché',
        accounting_account: 'Cpt comptable',
        grouping: 'Regroupement'
      },
    },
    table: {
      header: {
        title: 'Listes des Règles',
        new_groupuser: 'Nouveau',
      },
      filters: {
        state: '-Etat-',
        interface_generation: '-Interface génération-',
      },
      columns: {
        title: {
          state: 'Etat',
          code: 'Code',
          name: 'Nom',
          date: 'Date de modification',
          interface_generation: 'Interface génération',
          export_interface: 'Interface export',
          category_flux: 'Catégorie/Flux',
          auto_manuel: 'Auto/Manuel',
        },
      },
    },
  },
  brouillards: {
    table: {
      header: {
        title: 'Listes des générations brouillards',
        show: 'Visualiser',
      },
      modal: {
        title: 'Liste des sessions',
        buttons: {
          show: 'Visualiser',
          close: 'Annuler',
        },
      },
    },
    alert: 'Merci de sélectionner une règle pour la visualisation',
    detail: {
      Number: 'Numéro',
      title: 'Génération Visualisation',
      Back: 'Retour',
      fog_validate: 'Valider Brouillard',
      getting_file: 'Récupération fichier',
      session:'Modification de masse'
    },
    columns: {
      generation_interface: 'Génération interface',
      rule: 'Règle',
      event_type: 'Type Évènement',
      event_subtype: 'Sous type Évènement',
      category_flux: 'Catégorie/Flux',
      company: 'Société',
      account: 'Compte',
      amount_value: 'Montant',
      currency: 'Devise',
      accounting_date: 'Date comptable',
      creating_date: 'Date création',
      title_modal:'Modifier un écriture'
    },
  },
  interfaces: { 
    fiche: {
      title: {
        new_title: "Création d'une nouvelle interface de génération",
        edit_title: "Fiche de l'interface de génération du format {{code}}",
        general: 'Generale',
        company: 'Liste des sociétés membres',
        account: 'Liste des comptes membres',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        add: 'Ajouter',
        close: 'Fermer',
      },
      modal: {
        title: {
          info: 'Liste des mots-clés',
          company: 'Sélection de sociétés',
          account: 'Sélection de comptes bancaires',
        },
        information: {
          now: 'Date du jour format AAMMJJ',
          year: 'Année sur 2 caractères suivi du quantième',
          hour1: 'Heure au format HHMMSS',
          hour2: 'Heure au format HHMMSSCCC',
          bank_name: 'Nom de la banque',
          interface_code: "Code de l'interface",
        },
      },
      champ_titles: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        connector: 'Connecteur',
        file_format: 'Format de fichier',
        naming: 'Nommage',
        mode_generation: 'Génération mode',
      },
    },
    table: {
      header: {
        title: 'Liste des interfaces de génération',
      },
      columns: {
        code: 'Code',
        name: 'Nom',
        format: 'Format',
        connector: 'Connecteur',
        state: 'Etat',
        update_timestamp: 'Date modification',
      },
    },
  },
};
